/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 505:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/toConsumableArray");

/***/ }),

/***/ 3296:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.map.js");

/***/ }),

/***/ 3384:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectSpread2");

/***/ }),

/***/ 4860:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _objectSpread = (__webpack_require__(3384)["default"]);
var _toConsumableArray = (__webpack_require__(505)["default"]);
__webpack_require__(7436);
__webpack_require__(3296);
/* istanbul ignore file */

var basicIcons = [{
  name: 'Android',
  path: './packages/icons/src/Android.js'
}, {
  name: 'ArrowDown',
  path: './packages/icons/src/ArrowDown.js'
}, {
  name: 'Battery',
  path: './packages/icons/src/Battery.js'
}, {
  name: 'Bluetooth',
  path: './packages/icons/src/Bluetooth.js'
}, {
  name: 'CalendarCheck',
  path: './packages/icons/src/CalendarCheck.js'
}, {
  name: 'CalendarSimple',
  path: './packages/icons/src/CalendarSimple.js'
}, {
  name: 'Check',
  path: './packages/icons/src/Check.js'
}, {
  name: 'Circle',
  path: './packages/icons/src/Circle.js'
}, {
  name: 'Clock',
  path: './packages/icons/src/Clock.js'
}, {
  name: 'Coil',
  path: './packages/icons/src/Coil.js'
}, {
  name: 'Credits',
  path: './packages/icons/src/Credits.js'
}, {
  name: 'DebitCard',
  path: './packages/icons/src/DebitCard.js'
}, {
  name: 'DollarBill',
  path: './packages/icons/src/DollarBill.js'
}, {
  name: 'Download',
  path: './packages/icons/src/Download.js'
}, {
  name: 'FastShipping',
  path: './packages/icons/src/FastShipping.js'
}, {
  name: 'Help',
  path: './packages/icons/src/Help.js'
}, {
  name: 'Laptop',
  path: './packages/icons/src/Laptop.js'
}, {
  name: 'Light',
  path: './packages/icons/src/Light.js'
}, {
  name: 'MercadoCredito',
  path: './packages/icons/src/MercadoCredito.js'
}, {
  name: 'Money',
  path: './packages/icons/src/Money.js'
}, {
  name: 'Padlock',
  path: './packages/icons/src/Padlock.js'
}, {
  name: 'Payment',
  path: './packages/icons/src/Payment.js'
}, {
  name: 'People',
  path: './packages/icons/src/People.js'
}, {
  name: 'Phone',
  path: './packages/icons/src/Phone.js'
}, {
  name: 'PhoneTopUp',
  path: './packages/icons/src/PhoneTopUp.js'
}, {
  name: 'PhoneTopUpArrow',
  path: './packages/icons/src/PhoneTopUpArrow.js'
}, {
  name: 'PickUp',
  path: './packages/icons/src/PickUp.js'
}, {
  name: 'PointSmart',
  path: './packages/icons/src/PointSmart.js'
}, {
  name: 'Shield',
  path: './packages/icons/src/Shield.js'
}, {
  name: 'Shipping',
  path: './packages/icons/src/Shipping.js'
}, {
  name: 'Size',
  path: './packages/icons/src/Size.js'
}, {
  name: 'SpecialDiscount',
  path: './packages/icons/src/SpecialDiscount.js'
}, {
  name: 'Ticket',
  path: './packages/icons/src/Ticket.js'
}, {
  name: 'Warranty',
  path: './packages/icons/src/Warranty.js'
}, {
  name: 'Weight',
  path: './packages/icons/src/Weight.js'
}, {
  name: 'SimpleCheck',
  path: './packages/icons/src/SimpleCheck.js'
}, {
  name: 'ContactLessSimple',
  path: './packages/icons/src/ContactLessSimple.js'
}, {
  name: 'WifiSimple',
  path: './packages/icons/src/WifiSimple.js'
}, {
  name: 'WhatsApp',
  path: './packages/icons/src/WhatsApp.js'
}];
var circledIcons = [{
  name: 'Calendar',
  path: './packages/icons/src/Calendar.js'
}, {
  name: 'CircleCard',
  path: './packages/icons/src/CircleCard.js'
}, {
  name: 'ContactLess',
  path: './packages/icons/src/ContactLess.js'
}, {
  name: 'QrCode',
  path: './packages/icons/src/QrCode.js'
}, {
  name: 'Wifi',
  path: './packages/icons/src/Wifi.js'
}];
var cardIcons = [{
  name: 'FeedbackError',
  path: './packages/icons/src/FeedbackError.js'
}, {
  name: 'FeedbackSuccess',
  path: './packages/icons/src/FeedbackSuccess.js'
}, {
  name: 'ShortcutSimpleMobile',
  path: './packages/icons/src/ShortcutSimpleMobile.js'
}, {
  name: 'ShortcutSimpleDesktop',
  path: './packages/icons/src/ShortcutSimpleDesktop.js'
}, {
  name: 'ShortcutMoneyMobile',
  path: './packages/icons/src/ShortcutMoneyMobile.js'
}, {
  name: 'ShortcutMoneyDesktop',
  path: './packages/icons/src/ShortcutMoneyDesktop.js'
}, {
  name: 'ShortcutCreditsMobile',
  path: './packages/icons/src/ShortcutCreditsMobile.js'
}, {
  name: 'ShortcutCreditsDesktop',
  path: './packages/icons/src/ShortcutCreditsDesktop.js'
}, {
  name: 'ShortcutAccountMobile',
  path: './packages/icons/src/ShortcutAccountMobile.js'
}, {
  name: 'ShortcutAccountDesktop',
  path: './packages/icons/src/ShortcutAccountDesktop.js'
}];
var flagIcons = [{
  name: 'FlagMCO',
  path: './packages/icons/src/FlagMCO.js'
}, {
  name: 'FlagMLA',
  path: './packages/icons/src/FlagMLA.js'
}, {
  name: 'FlagMLB',
  path: './packages/icons/src/FlagMLB.js'
}, {
  name: 'FlagMLC',
  path: './packages/icons/src/FlagMLC.js'
}, {
  name: 'FlagMLM',
  path: './packages/icons/src/FlagMLM.js'
}, {
  name: 'FlagMLU',
  path: './packages/icons/src/FlagMLU.js'
}, {
  name: 'FlagMPE',
  path: './packages/icons/src/FlagMPE.js'
}, {
  name: 'FlagMUS',
  path: './packages/icons/src/FlagMUS.js'
}];
var bottomBackgroundCurves = [{
  name: 'TwinConcaveWavesBackground',
  path: './packages/icons/src/svgEffects/TwinConcaveWavesBackground.js'
}, {
  name: 'TwinWavesBackground',
  path: './packages/icons/src/svgEffects/TwinWavesBackground.js'
}, {
  name: 'WavesBackground',
  path: './packages/icons/src/svgEffects/WavesBackground.js'
}, {
  name: 'MinimalWave',
  path: './packages/icons/src/svgEffects/MinimalWave.js'
}];
var logoIcons = [{
  name: 'MercadoLibre',
  path: './packages/icons/src/MercadoLibre.js'
}];
var feesSectionIcons = [{
  name: 'BankTransfer',
  path: './packages/icons/src/BankTransfer.js'
}, {
  name: 'Barcode',
  path: './packages/icons/src/Barcode.js'
}, {
  name: 'Card',
  path: './packages/icons/src/Card.js'
}, {
  name: 'Cash',
  path: './packages/icons/src/Cash.js'
}, {
  name: 'Debit',
  path: './packages/icons/src/Debit.js'
}, {
  name: 'MercadoPagoCard',
  path: './packages/icons/src/MercadoPagoCard.js'
}, {
  name: 'Pix',
  path: './packages/icons/src/Pix.js'
}, {
  name: 'MercadoPagoLogo',
  path: './packages/icons/src/MercadoPagoLogo.js'
}, {
  name: 'MercadoCreditoLogo',
  path: './packages/icons/src/MercadoCreditoLogo.js'
}];
var numberIcons = [{
  name: 'NumberOne',
  path: './packages/icons/src/NumberOne.js'
}, {
  name: 'NumberTwo',
  path: './packages/icons/src/NumberTwo.js'
}, {
  name: 'NumberThree',
  path: './packages/icons/src/NumberThree.js'
}, {
  name: 'NumberFour',
  path: './packages/icons/src/NumberFour.js'
}, {
  name: 'NumberFive',
  path: './packages/icons/src/NumberFive.js'
}, {
  name: 'NumberSix',
  path: './packages/icons/src/NumberSix.js'
}, {
  name: 'NumberSeven',
  path: './packages/icons/src/NumberSeven.js'
}, {
  name: 'NumberEight',
  path: './packages/icons/src/NumberEight.js'
}, {
  name: 'NumberNine',
  path: './packages/icons/src/NumberNine.js'
}];
module.exports = [].concat(_toConsumableArray(basicIcons.map(function (icon) {
  return _objectSpread(_objectSpread({}, icon), {}, {
    type: 'basic'
  });
})), _toConsumableArray(circledIcons.map(function (icon) {
  return _objectSpread(_objectSpread({}, icon), {}, {
    type: 'circled'
  });
})), _toConsumableArray(cardIcons.map(function (icon) {
  return _objectSpread(_objectSpread({}, icon), {}, {
    type: 'card'
  });
})), _toConsumableArray(flagIcons.map(function (icon) {
  return _objectSpread(_objectSpread({}, icon), {}, {
    type: 'flag'
  });
})), _toConsumableArray(logoIcons.map(function (icon) {
  return _objectSpread(_objectSpread({}, icon), {}, {
    type: 'logo'
  });
})), _toConsumableArray(bottomBackgroundCurves.map(function (icon) {
  return _objectSpread(_objectSpread({}, icon), {}, {
    type: 'bottom-curve'
  });
})), _toConsumableArray(feesSectionIcons.map(function (icon) {
  return _objectSpread(_objectSpread({}, icon), {}, {
    type: 'fees-section-icons'
  });
})), _toConsumableArray(numberIcons.map(function (icon) {
  return _objectSpread(_objectSpread({}, icon), {}, {
    type: 'number-icons'
  });
})));

/***/ }),

/***/ 7436:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.concat.js");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ icons)
});

// NAMESPACE OBJECT: ./packages/icons/src/Icons.js
var Icons_namespaceObject = {};
__webpack_require__.r(Icons_namespaceObject);
__webpack_require__.d(Icons_namespaceObject, {
  Android: () => ((Android_default())),
  ArrowDown: () => ((ArrowDown_default())),
  BankTransfer: () => ((BankTransfer_default())),
  Barcode: () => ((Barcode_default())),
  Battery: () => ((Battery_default())),
  Bluetooth: () => ((Bluetooth_default())),
  Calendar: () => ((Calendar_default())),
  CalendarCheck: () => ((CalendarCheck_default())),
  CalendarSimple: () => ((CalendarSimple_default())),
  Card: () => ((Card_default())),
  Cash: () => ((Cash_default())),
  Check: () => ((Check_default())),
  Circle: () => ((Circle_default())),
  CircleCard: () => ((CircleCard_default())),
  Clock: () => ((Clock_default())),
  Coil: () => ((Coil_default())),
  ContactLess: () => ((ContactLess_default())),
  ContactLessSimple: () => ((ContactLessSimple_default())),
  Credits: () => ((Credits_default())),
  Debit: () => ((Debit_default())),
  DebitCard: () => ((DebitCard_default())),
  DollarBill: () => ((DollarBill_default())),
  Download: () => ((Download_default())),
  FastShipping: () => ((FastShipping_default())),
  FeedbackError: () => ((FeedbackError_default())),
  FeedbackSuccess: () => ((FeedbackSuccess_default())),
  FlagMCO: () => ((FlagMCO_default())),
  FlagMLA: () => ((FlagMLA_default())),
  FlagMLB: () => ((FlagMLB_default())),
  FlagMLC: () => ((FlagMLC_default())),
  FlagMLM: () => ((FlagMLM_default())),
  FlagMLU: () => ((FlagMLU_default())),
  FlagMPE: () => ((FlagMPE_default())),
  FlagMUS: () => ((FlagMUS_default())),
  GROUPED_ICONS: () => ((entry_points_default())),
  Help: () => ((Help_default())),
  Laptop: () => ((Laptop_default())),
  Light: () => ((Light_default())),
  MercadoCredito: () => ((MercadoCredito_default())),
  MercadoCreditoLogo: () => ((MercadoCreditoLogo_default())),
  MercadoLibre: () => ((MercadoLibre_default())),
  MercadoPagoCard: () => ((MercadoPagoCard_default())),
  MercadoPagoLogo: () => ((MercadoPagoLogo_default())),
  MinimalWave: () => ((MinimalWave_default())),
  Money: () => ((Money_default())),
  NumberEight: () => ((NumberEight_default())),
  NumberFive: () => ((NumberFive_default())),
  NumberFour: () => ((NumberFour_default())),
  NumberNine: () => ((NumberNine_default())),
  NumberOne: () => ((NumberOne_default())),
  NumberSeven: () => ((NumberSeven_default())),
  NumberSix: () => ((NumberSix_default())),
  NumberThree: () => ((NumberThree_default())),
  NumberTwo: () => ((NumberTwo_default())),
  Padlock: () => ((Padlock_default())),
  Payment: () => ((Payment_default())),
  People: () => ((People_default())),
  Phone: () => ((Phone_default())),
  PhoneTopUp: () => ((PhoneTopUp_default())),
  PhoneTopUpArrow: () => ((PhoneTopUpArrow_default())),
  PickUp: () => ((PickUp_default())),
  Pix: () => ((Pix_default())),
  PointSmart: () => ((PointSmart_default())),
  QrCode: () => ((QrCode_default())),
  Shield: () => ((Shield_default())),
  Shipping: () => ((Shipping_default())),
  ShortcutAccountDesktop: () => ((ShortcutAccountDesktop_default())),
  ShortcutAccountMobile: () => ((ShortcutAccountMobile_default())),
  ShortcutCreditsDesktop: () => ((ShortcutCreditsDesktop_default())),
  ShortcutCreditsMobile: () => ((ShortcutCreditsMobile_default())),
  ShortcutMoneyDesktop: () => ((ShortcutMoneyDesktop_default())),
  ShortcutMoneyMobile: () => ((ShortcutMoneyMobile_default())),
  ShortcutSimpleDesktop: () => ((ShortcutSimpleDesktop_default())),
  ShortcutSimpleMobile: () => ((ShortcutSimpleMobile_default())),
  SimpleCheck: () => ((SimpleCheck_default())),
  Size: () => ((Size_default())),
  SpecialDiscount: () => ((SpecialDiscount_default())),
  Ticket: () => ((Ticket_default())),
  TwinConcaveWavesBackground: () => ((TwinConcaveWavesBackground_default())),
  TwinWavesBackground: () => ((TwinWavesBackground_default())),
  Warranty: () => ((Warranty_default())),
  WavesBackground: () => ((WavesBackground_default())),
  Weight: () => ((Weight_default())),
  WhatsApp: () => ((WhatsApp_default())),
  Wifi: () => ((Wifi_default())),
  WifiSimple: () => ((WifiSimple_default()))
});

// EXTERNAL MODULE: ./packages/icons/entry-points.js
var entry_points = __webpack_require__(4860);
var entry_points_default = /*#__PURE__*/__webpack_require__.n(entry_points);
;// external "@pog-ui-landings-library/icons/lib/Android"
const Android_namespaceObject = require("@pog-ui-landings-library/icons/lib/Android");
var Android_default = /*#__PURE__*/__webpack_require__.n(Android_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ArrowDown"
const ArrowDown_namespaceObject = require("@pog-ui-landings-library/icons/lib/ArrowDown");
var ArrowDown_default = /*#__PURE__*/__webpack_require__.n(ArrowDown_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/BankTransfer"
const BankTransfer_namespaceObject = require("@pog-ui-landings-library/icons/lib/BankTransfer");
var BankTransfer_default = /*#__PURE__*/__webpack_require__.n(BankTransfer_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Barcode"
const Barcode_namespaceObject = require("@pog-ui-landings-library/icons/lib/Barcode");
var Barcode_default = /*#__PURE__*/__webpack_require__.n(Barcode_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Battery"
const Battery_namespaceObject = require("@pog-ui-landings-library/icons/lib/Battery");
var Battery_default = /*#__PURE__*/__webpack_require__.n(Battery_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Bluetooth"
const Bluetooth_namespaceObject = require("@pog-ui-landings-library/icons/lib/Bluetooth");
var Bluetooth_default = /*#__PURE__*/__webpack_require__.n(Bluetooth_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Calendar"
const Calendar_namespaceObject = require("@pog-ui-landings-library/icons/lib/Calendar");
var Calendar_default = /*#__PURE__*/__webpack_require__.n(Calendar_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/CalendarCheck"
const CalendarCheck_namespaceObject = require("@pog-ui-landings-library/icons/lib/CalendarCheck");
var CalendarCheck_default = /*#__PURE__*/__webpack_require__.n(CalendarCheck_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/CalendarSimple"
const CalendarSimple_namespaceObject = require("@pog-ui-landings-library/icons/lib/CalendarSimple");
var CalendarSimple_default = /*#__PURE__*/__webpack_require__.n(CalendarSimple_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Card"
const Card_namespaceObject = require("@pog-ui-landings-library/icons/lib/Card");
var Card_default = /*#__PURE__*/__webpack_require__.n(Card_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Cash"
const Cash_namespaceObject = require("@pog-ui-landings-library/icons/lib/Cash");
var Cash_default = /*#__PURE__*/__webpack_require__.n(Cash_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Check"
const Check_namespaceObject = require("@pog-ui-landings-library/icons/lib/Check");
var Check_default = /*#__PURE__*/__webpack_require__.n(Check_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Circle"
const Circle_namespaceObject = require("@pog-ui-landings-library/icons/lib/Circle");
var Circle_default = /*#__PURE__*/__webpack_require__.n(Circle_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/CircleCard"
const CircleCard_namespaceObject = require("@pog-ui-landings-library/icons/lib/CircleCard");
var CircleCard_default = /*#__PURE__*/__webpack_require__.n(CircleCard_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Credits"
const Credits_namespaceObject = require("@pog-ui-landings-library/icons/lib/Credits");
var Credits_default = /*#__PURE__*/__webpack_require__.n(Credits_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Coil"
const Coil_namespaceObject = require("@pog-ui-landings-library/icons/lib/Coil");
var Coil_default = /*#__PURE__*/__webpack_require__.n(Coil_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ContactLess"
const ContactLess_namespaceObject = require("@pog-ui-landings-library/icons/lib/ContactLess");
var ContactLess_default = /*#__PURE__*/__webpack_require__.n(ContactLess_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ContactLessSimple"
const ContactLessSimple_namespaceObject = require("@pog-ui-landings-library/icons/lib/ContactLessSimple");
var ContactLessSimple_default = /*#__PURE__*/__webpack_require__.n(ContactLessSimple_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Debit"
const Debit_namespaceObject = require("@pog-ui-landings-library/icons/lib/Debit");
var Debit_default = /*#__PURE__*/__webpack_require__.n(Debit_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Download"
const Download_namespaceObject = require("@pog-ui-landings-library/icons/lib/Download");
var Download_default = /*#__PURE__*/__webpack_require__.n(Download_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FastShipping"
const FastShipping_namespaceObject = require("@pog-ui-landings-library/icons/lib/FastShipping");
var FastShipping_default = /*#__PURE__*/__webpack_require__.n(FastShipping_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FeedbackError"
const FeedbackError_namespaceObject = require("@pog-ui-landings-library/icons/lib/FeedbackError");
var FeedbackError_default = /*#__PURE__*/__webpack_require__.n(FeedbackError_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FeedbackSuccess"
const FeedbackSuccess_namespaceObject = require("@pog-ui-landings-library/icons/lib/FeedbackSuccess");
var FeedbackSuccess_default = /*#__PURE__*/__webpack_require__.n(FeedbackSuccess_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FlagMCO"
const FlagMCO_namespaceObject = require("@pog-ui-landings-library/icons/lib/FlagMCO");
var FlagMCO_default = /*#__PURE__*/__webpack_require__.n(FlagMCO_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FlagMLA"
const FlagMLA_namespaceObject = require("@pog-ui-landings-library/icons/lib/FlagMLA");
var FlagMLA_default = /*#__PURE__*/__webpack_require__.n(FlagMLA_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FlagMLB"
const FlagMLB_namespaceObject = require("@pog-ui-landings-library/icons/lib/FlagMLB");
var FlagMLB_default = /*#__PURE__*/__webpack_require__.n(FlagMLB_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FlagMLC"
const FlagMLC_namespaceObject = require("@pog-ui-landings-library/icons/lib/FlagMLC");
var FlagMLC_default = /*#__PURE__*/__webpack_require__.n(FlagMLC_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FlagMLM"
const FlagMLM_namespaceObject = require("@pog-ui-landings-library/icons/lib/FlagMLM");
var FlagMLM_default = /*#__PURE__*/__webpack_require__.n(FlagMLM_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FlagMLU"
const FlagMLU_namespaceObject = require("@pog-ui-landings-library/icons/lib/FlagMLU");
var FlagMLU_default = /*#__PURE__*/__webpack_require__.n(FlagMLU_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FlagMPE"
const FlagMPE_namespaceObject = require("@pog-ui-landings-library/icons/lib/FlagMPE");
var FlagMPE_default = /*#__PURE__*/__webpack_require__.n(FlagMPE_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/FlagMUS"
const FlagMUS_namespaceObject = require("@pog-ui-landings-library/icons/lib/FlagMUS");
var FlagMUS_default = /*#__PURE__*/__webpack_require__.n(FlagMUS_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Help"
const Help_namespaceObject = require("@pog-ui-landings-library/icons/lib/Help");
var Help_default = /*#__PURE__*/__webpack_require__.n(Help_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Laptop"
const Laptop_namespaceObject = require("@pog-ui-landings-library/icons/lib/Laptop");
var Laptop_default = /*#__PURE__*/__webpack_require__.n(Laptop_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Light"
const Light_namespaceObject = require("@pog-ui-landings-library/icons/lib/Light");
var Light_default = /*#__PURE__*/__webpack_require__.n(Light_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/MercadoCredito"
const MercadoCredito_namespaceObject = require("@pog-ui-landings-library/icons/lib/MercadoCredito");
var MercadoCredito_default = /*#__PURE__*/__webpack_require__.n(MercadoCredito_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/MercadoLibre"
const MercadoLibre_namespaceObject = require("@pog-ui-landings-library/icons/lib/MercadoLibre");
var MercadoLibre_default = /*#__PURE__*/__webpack_require__.n(MercadoLibre_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/MercadoPagoCard"
const MercadoPagoCard_namespaceObject = require("@pog-ui-landings-library/icons/lib/MercadoPagoCard");
var MercadoPagoCard_default = /*#__PURE__*/__webpack_require__.n(MercadoPagoCard_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/MercadoPagoLogo"
const MercadoPagoLogo_namespaceObject = require("@pog-ui-landings-library/icons/lib/MercadoPagoLogo");
var MercadoPagoLogo_default = /*#__PURE__*/__webpack_require__.n(MercadoPagoLogo_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/MercadoCreditoLogo"
const MercadoCreditoLogo_namespaceObject = require("@pog-ui-landings-library/icons/lib/MercadoCreditoLogo");
var MercadoCreditoLogo_default = /*#__PURE__*/__webpack_require__.n(MercadoCreditoLogo_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Money"
const Money_namespaceObject = require("@pog-ui-landings-library/icons/lib/Money");
var Money_default = /*#__PURE__*/__webpack_require__.n(Money_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/NumberOne"
const NumberOne_namespaceObject = require("@pog-ui-landings-library/icons/lib/NumberOne");
var NumberOne_default = /*#__PURE__*/__webpack_require__.n(NumberOne_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/NumberTwo"
const NumberTwo_namespaceObject = require("@pog-ui-landings-library/icons/lib/NumberTwo");
var NumberTwo_default = /*#__PURE__*/__webpack_require__.n(NumberTwo_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/NumberThree"
const NumberThree_namespaceObject = require("@pog-ui-landings-library/icons/lib/NumberThree");
var NumberThree_default = /*#__PURE__*/__webpack_require__.n(NumberThree_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/NumberFour"
const NumberFour_namespaceObject = require("@pog-ui-landings-library/icons/lib/NumberFour");
var NumberFour_default = /*#__PURE__*/__webpack_require__.n(NumberFour_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/NumberFive"
const NumberFive_namespaceObject = require("@pog-ui-landings-library/icons/lib/NumberFive");
var NumberFive_default = /*#__PURE__*/__webpack_require__.n(NumberFive_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/NumberSix"
const NumberSix_namespaceObject = require("@pog-ui-landings-library/icons/lib/NumberSix");
var NumberSix_default = /*#__PURE__*/__webpack_require__.n(NumberSix_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/NumberSeven"
const NumberSeven_namespaceObject = require("@pog-ui-landings-library/icons/lib/NumberSeven");
var NumberSeven_default = /*#__PURE__*/__webpack_require__.n(NumberSeven_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/NumberEight"
const NumberEight_namespaceObject = require("@pog-ui-landings-library/icons/lib/NumberEight");
var NumberEight_default = /*#__PURE__*/__webpack_require__.n(NumberEight_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/NumberNine"
const NumberNine_namespaceObject = require("@pog-ui-landings-library/icons/lib/NumberNine");
var NumberNine_default = /*#__PURE__*/__webpack_require__.n(NumberNine_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Padlock"
const Padlock_namespaceObject = require("@pog-ui-landings-library/icons/lib/Padlock");
var Padlock_default = /*#__PURE__*/__webpack_require__.n(Padlock_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Payment"
const Payment_namespaceObject = require("@pog-ui-landings-library/icons/lib/Payment");
var Payment_default = /*#__PURE__*/__webpack_require__.n(Payment_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/People"
const People_namespaceObject = require("@pog-ui-landings-library/icons/lib/People");
var People_default = /*#__PURE__*/__webpack_require__.n(People_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/PhoneTopUp"
const PhoneTopUp_namespaceObject = require("@pog-ui-landings-library/icons/lib/PhoneTopUp");
var PhoneTopUp_default = /*#__PURE__*/__webpack_require__.n(PhoneTopUp_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/PickUp"
const PickUp_namespaceObject = require("@pog-ui-landings-library/icons/lib/PickUp");
var PickUp_default = /*#__PURE__*/__webpack_require__.n(PickUp_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Pix"
const Pix_namespaceObject = require("@pog-ui-landings-library/icons/lib/Pix");
var Pix_default = /*#__PURE__*/__webpack_require__.n(Pix_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Shield"
const Shield_namespaceObject = require("@pog-ui-landings-library/icons/lib/Shield");
var Shield_default = /*#__PURE__*/__webpack_require__.n(Shield_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ShortcutSimpleMobile"
const ShortcutSimpleMobile_namespaceObject = require("@pog-ui-landings-library/icons/lib/ShortcutSimpleMobile");
var ShortcutSimpleMobile_default = /*#__PURE__*/__webpack_require__.n(ShortcutSimpleMobile_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ShortcutSimpleDesktop"
const ShortcutSimpleDesktop_namespaceObject = require("@pog-ui-landings-library/icons/lib/ShortcutSimpleDesktop");
var ShortcutSimpleDesktop_default = /*#__PURE__*/__webpack_require__.n(ShortcutSimpleDesktop_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ShortcutMoneyMobile"
const ShortcutMoneyMobile_namespaceObject = require("@pog-ui-landings-library/icons/lib/ShortcutMoneyMobile");
var ShortcutMoneyMobile_default = /*#__PURE__*/__webpack_require__.n(ShortcutMoneyMobile_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ShortcutMoneyDesktop"
const ShortcutMoneyDesktop_namespaceObject = require("@pog-ui-landings-library/icons/lib/ShortcutMoneyDesktop");
var ShortcutMoneyDesktop_default = /*#__PURE__*/__webpack_require__.n(ShortcutMoneyDesktop_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ShortcutCreditsMobile"
const ShortcutCreditsMobile_namespaceObject = require("@pog-ui-landings-library/icons/lib/ShortcutCreditsMobile");
var ShortcutCreditsMobile_default = /*#__PURE__*/__webpack_require__.n(ShortcutCreditsMobile_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ShortcutCreditsDesktop"
const ShortcutCreditsDesktop_namespaceObject = require("@pog-ui-landings-library/icons/lib/ShortcutCreditsDesktop");
var ShortcutCreditsDesktop_default = /*#__PURE__*/__webpack_require__.n(ShortcutCreditsDesktop_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ShortcutAccountMobile"
const ShortcutAccountMobile_namespaceObject = require("@pog-ui-landings-library/icons/lib/ShortcutAccountMobile");
var ShortcutAccountMobile_default = /*#__PURE__*/__webpack_require__.n(ShortcutAccountMobile_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/ShortcutAccountDesktop"
const ShortcutAccountDesktop_namespaceObject = require("@pog-ui-landings-library/icons/lib/ShortcutAccountDesktop");
var ShortcutAccountDesktop_default = /*#__PURE__*/__webpack_require__.n(ShortcutAccountDesktop_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Size"
const Size_namespaceObject = require("@pog-ui-landings-library/icons/lib/Size");
var Size_default = /*#__PURE__*/__webpack_require__.n(Size_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/SpecialDiscount"
const SpecialDiscount_namespaceObject = require("@pog-ui-landings-library/icons/lib/SpecialDiscount");
var SpecialDiscount_default = /*#__PURE__*/__webpack_require__.n(SpecialDiscount_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Ticket"
const Ticket_namespaceObject = require("@pog-ui-landings-library/icons/lib/Ticket");
var Ticket_default = /*#__PURE__*/__webpack_require__.n(Ticket_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/TwinConcaveWavesBackground"
const TwinConcaveWavesBackground_namespaceObject = require("@pog-ui-landings-library/icons/lib/TwinConcaveWavesBackground");
var TwinConcaveWavesBackground_default = /*#__PURE__*/__webpack_require__.n(TwinConcaveWavesBackground_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/TwinWavesBackground"
const TwinWavesBackground_namespaceObject = require("@pog-ui-landings-library/icons/lib/TwinWavesBackground");
var TwinWavesBackground_default = /*#__PURE__*/__webpack_require__.n(TwinWavesBackground_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/WavesBackground"
const WavesBackground_namespaceObject = require("@pog-ui-landings-library/icons/lib/WavesBackground");
var WavesBackground_default = /*#__PURE__*/__webpack_require__.n(WavesBackground_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Weight"
const Weight_namespaceObject = require("@pog-ui-landings-library/icons/lib/Weight");
var Weight_default = /*#__PURE__*/__webpack_require__.n(Weight_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Wifi"
const Wifi_namespaceObject = require("@pog-ui-landings-library/icons/lib/Wifi");
var Wifi_default = /*#__PURE__*/__webpack_require__.n(Wifi_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Clock"
const Clock_namespaceObject = require("@pog-ui-landings-library/icons/lib/Clock");
var Clock_default = /*#__PURE__*/__webpack_require__.n(Clock_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Warranty"
const Warranty_namespaceObject = require("@pog-ui-landings-library/icons/lib/Warranty");
var Warranty_default = /*#__PURE__*/__webpack_require__.n(Warranty_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/QrCode"
const QrCode_namespaceObject = require("@pog-ui-landings-library/icons/lib/QrCode");
var QrCode_default = /*#__PURE__*/__webpack_require__.n(QrCode_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/SimpleCheck"
const SimpleCheck_namespaceObject = require("@pog-ui-landings-library/icons/lib/SimpleCheck");
var SimpleCheck_default = /*#__PURE__*/__webpack_require__.n(SimpleCheck_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/MinimalWave"
const MinimalWave_namespaceObject = require("@pog-ui-landings-library/icons/lib/MinimalWave");
var MinimalWave_default = /*#__PURE__*/__webpack_require__.n(MinimalWave_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/WifiSimple"
const WifiSimple_namespaceObject = require("@pog-ui-landings-library/icons/lib/WifiSimple");
var WifiSimple_default = /*#__PURE__*/__webpack_require__.n(WifiSimple_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/WhatsApp"
const WhatsApp_namespaceObject = require("@pog-ui-landings-library/icons/lib/WhatsApp");
var WhatsApp_default = /*#__PURE__*/__webpack_require__.n(WhatsApp_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Phone"
const Phone_namespaceObject = require("@pog-ui-landings-library/icons/lib/Phone");
var Phone_default = /*#__PURE__*/__webpack_require__.n(Phone_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/DebitCard"
const DebitCard_namespaceObject = require("@pog-ui-landings-library/icons/lib/DebitCard");
var DebitCard_default = /*#__PURE__*/__webpack_require__.n(DebitCard_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/DollarBill"
const DollarBill_namespaceObject = require("@pog-ui-landings-library/icons/lib/DollarBill");
var DollarBill_default = /*#__PURE__*/__webpack_require__.n(DollarBill_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/PhoneTopUpArrow"
const PhoneTopUpArrow_namespaceObject = require("@pog-ui-landings-library/icons/lib/PhoneTopUpArrow");
var PhoneTopUpArrow_default = /*#__PURE__*/__webpack_require__.n(PhoneTopUpArrow_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/PointSmart"
const PointSmart_namespaceObject = require("@pog-ui-landings-library/icons/lib/PointSmart");
var PointSmart_default = /*#__PURE__*/__webpack_require__.n(PointSmart_namespaceObject);
;// external "@pog-ui-landings-library/icons/lib/Shipping"
const Shipping_namespaceObject = require("@pog-ui-landings-library/icons/lib/Shipping");
var Shipping_default = /*#__PURE__*/__webpack_require__.n(Shipping_namespaceObject);
;// ./packages/icons/src/Icons.js
/* istanbul ignore file */






















































































;// ./packages/icons/index.js

/* harmony default export */ const icons = (Icons_namespaceObject);
})();

module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.production.js.map